import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MediasService } from '../../../../../services/medias.service';
import { ReelsService } from '../../../../../services/reels.service';
import { Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BroadcastService } from '../../../../../shared/services/broadcast.service';
import { takeUntil } from 'rxjs/operators';
import { GroupsService } from '../../../../../services/groups.service';
import { UnitssService } from '../../../../../services/unitss.service';

@Component({
	selector: 'app-config-groups',
	templateUrl: './config-groups.component.html',
	styleUrls: ['./config-groups.component.scss']
})
export class ConfigGroupsComponent implements OnInit, OnDestroy {
	@Input() data: any = {};
	units: any = [];
	selectedUnits: any = [];
	group: any;

	private atComponentDestroy = new Subject();

	constructor(
		private unitsService: UnitssService,
		private groupsService: GroupsService,
		public modalRef: BsModalRef,
	) { }


	ngOnDestroy(): void {
		this.atComponentDestroy.next();
		this.atComponentDestroy.unsubscribe();
	}

	async ngOnInit(): Promise<void> {
		const groupResponse = await this.groupsService.show(this.data.id);
		this.group = groupResponse.response;
		this.selectedUnits = [... this.group.unitss];
		this.units = await this.unitsService.getUnits();

		this.selectedUnits.forEach(item => {
			const selectedMediaIndex = this.units.findIndex((element) => element.id === item.id);
			if (selectedMediaIndex >= 0) {
				this.units.splice(selectedMediaIndex, 1);
			}

		});

	}

	/**
	 * Send the data to the server
	 */
	submit(): void {
		const selectedValues = [];
		this.selectedUnits.forEach(element => {
			selectedValues.push(element.id);
		});

		this.groupsService.saveUnits(selectedValues, this.data.id)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(
				data => {
					this.modalRef.hide();
				}
			);
	}

}
